import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { escucharErrores, vigilarAvisos } from "@/lib/rastro";

// El rastro de fallos (lib/rastro): los avisos de error que ve el cliente y los errores
// de JavaScript que no recoge nadie.
vigilarAvisos(toast);
escucharErrores();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: registrar el service worker (solo fuera de localhost; en desarrollo
// molesta y no aporta). Hace la app instalable desde el navegador.
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
